import { render, staticRenderFns } from "./ListarCor.vue?vue&type=template&id=3b99b82f"
import script from "./ListarCor.vue?vue&type=script&lang=js"
export * from "./ListarCor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports